import React, { forwardRef, ForwardRefRenderFunction } from 'react';
import Head from 'next/head';

interface VideoProps {
  classes?: string;
  poster?: string;
  src: string;
  autoplay?: boolean;
  loop?: boolean;
  muted?: boolean;
  playsinline?: boolean;
  controls?: boolean;
}

const Video: ForwardRefRenderFunction<HTMLVideoElement, VideoProps> = (
  {
    classes,
    poster,
    autoplay = false,
    loop = true,
    muted = true,
    src,
    playsinline = true,
    controls = false,
  },
  ref,
) => {
  return (
    <>
      {/* Preload the image so it is available before the browser requests it */}
      {poster && (
        <Head>
          <link rel="preload" href={poster} as="image" fetchPriority="high" />
        </Head>
      )}
      <video
        poster={poster}
        data-testid="video"
        className={classes}
        autoPlay={autoplay}
        loop={loop}
        muted={muted}
        playsInline={playsinline}
        controls={controls}
        controlsList="play timeline volume nofullscreen nodownload noremoteplayback noplaybackrate"
        ref={ref}
      >
        <source type="video/mp4" src={src} />
      </video>
    </>
  );
};

export default React.memo(forwardRef(Video));
